export enum ContentFilterQueryParamKey {
  CATEGORY = 'category',
  TYPE = 'type',
}

export enum ContentFilterSortingOption {
  ALPHABETICAL = 1,
  ITEMS_COUNT = 2,
}

export enum ContentFilterDisplayVariant {
  HIDE_EXTRA_ITEMS = 1,
  SHOW_ALL_ITEMS = 2,
}

export type ContentFilterValue = {
  backLinks?: string;
  count?: number;
  label: string;
  value: string;
};

export type ContentFilterDataItem = {
  value: string;
  count: number;
};

export type ContentFiltersData = {
  categories: Array<ContentFilterDataItem>;
  types: Array<ContentFilterDataItem>;
};
